import ProductRating from '../ProductRating.vue';
import ProductCardMixin from '../../mixins/ProductCardMixin';
import RelatedProducts from './show/RelatedProducts.vue';

export default {
    components: {
        ProductRating,
        RelatedProducts,
    },

    mixins: [
        ProductCardMixin,
    ],

    props: [
        'product',
        'reviewCount',
        'avgRating',
    ],

    data() {
        return {
            activeTab: 'description',
        };
    },

    computed: {

        /**
         * Determine whether the logged-in user
         * has access to premium property information.
         */
        isMember() {
            if (!window.FleetCart || !window.FleetCart.isMember) {
                return false;
            }

            return window.FleetCart.isMember === true;
        },

        /**
         * Property location.
         */
        propertyLocation() {
            const parts = [];

            if (this.product.locality) {
                parts.push(this.product.locality);
            }

            if (this.product.city) {
                parts.push(this.product.city);
            }

            if (this.product.state) {
                parts.push(this.product.state);
            }

            return parts.join(', ');
        },

        /**
         * Formatted reserve price.
         */
        formattedReservePrice() {
            if (
                !this.isMember ||
                this.product.reserve_price === null ||
                typeof this.product.reserve_price === 'undefined'
            ) {
                return null;
            }

            return this.formatCurrency(this.product.reserve_price);
        },

        /**
         * Formatted EMD amount.
         */
        formattedEmdAmount() {
            if (
                !this.isMember ||
                this.product.emd_amount === null ||
                typeof this.product.emd_amount === 'undefined'
            ) {
                return null;
            }

            return this.formatCurrency(this.product.emd_amount);
        },

        /**
         * Formatted auction date.
         */
        formattedAuctionDate() {
            if (
                !this.isMember ||
                !this.product.auction_date
            ) {
                return null;
            }

            const date = new Date(this.product.auction_date);

            if (isNaN(date.getTime())) {
                return this.product.auction_date;
            }

            return date.toLocaleDateString('en-IN', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
            });
        },

    },

    methods: {

        /**
         * Format INR currency.
         */
        formatCurrency(value) {
            const amount = Number(value);

            if (isNaN(amount)) {
                return value;
            }

            return '₹' + amount.toLocaleString('en-IN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        },

        /**
         * Change active property tab.
         */
        changeTab(tab) {
            this.activeTab = tab;
        },

        /**
         * Scroll to a property section.
         */
        scrollToSection(selector) {
            const element = document.querySelector(selector);

            if (!element) {
                return;
            }

            const offset = 100;

            const top =
                element.getBoundingClientRect().top +
                window.pageYOffset -
                offset;

            window.scrollTo({
                top,
                behavior: 'smooth',
            });
        },

        /**
         * Open membership page.
         */
        goToMembership() {
            window.location.href = route('membership.index');
        },

        /**
         * Open login page.
         */
        goToLogin() {
            window.location.href = route('login');
        },

    },

};